<h1 mat-dialog-title> {{ data.Name }}</h1>
<div mat-dialog-content>

  <p>

    {{ "missingProductsForCategoryLabel" | translate:{category: "Gelo"} }}:

  </p>

  <ul>

    <li *ngFor="let item of GELO"> {{ item.qta }} x {{ item.name }}</li>

  </ul>

  <p>

    {{ "missingProductsForCategoryLabel" | translate:{category: "Fresco"} }}:

  </p>

  <ul>

    <li *ngFor="let item of FRESCO"> {{ item.qta }} x {{ item.name }}</li>

  </ul>


  <p>

    {{ "missingProductsForCategoryLabel" | translate:{category: "Secco"} }}:

  </p>

  <ul>

    <li *ngFor="let item of SECCO"> {{ item.qta }} x {{ item.name }}</li>

  </ul>

</div>
<div
  mat-dialog-actions
  fxLayout="row wrap"
  fxLayoutAlign="space-between center">
  <button mat-button color="warn" (click)="close()"> {{ "close" | translate }}</button>
</div>
